import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Search, UserX, X } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { PersonActivityCard } from "./PersonActivityCard";

const eur = (n) => `€${Number(n || 0).toFixed(2)}`;
const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("de-DE") : "—");

export default function UnregisteredBuyers() {
  const { authAxios } = useAuth();
  const [q, setQ] = useState("");
  const [rows, setRows] = useState(null);
  const [picked, setPicked] = useState(null);

  useEffect(() => {
    const t = setTimeout(() => {
      authAxios.get("/finance-admin/unregistered-buyers", { params: { search: q.trim() || undefined } })
        .then(r => setRows(r.data)).catch(e => toast.error(e.response?.data?.detail || "Could not load buyers"));
    }, 300);
    return () => clearTimeout(t);
  }, [q]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="bg-white rounded-2xl shadow-sm p-4" data-testid="unregistered-buyers">
      <div className="flex items-center justify-between gap-3 mb-3 flex-wrap">
        <div>
          <h3 className="font-bold text-[#1e3a5f] flex items-center gap-2"><UserX className="w-5 h-5" /> Unregistered buyers</h3>
          <p className="text-xs text-slate-500">People who bought in the shop without a member or guest account.</p>
        </div>
        <div className="relative w-full sm:w-72">
          <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
          <input value={q} onChange={e => setQ(e.target.value)} placeholder="Search email or name"
            className="w-full pl-9 pr-3 py-2 rounded-xl border text-sm" data-testid="unregistered-search-input" />
        </div>
      </div>
      {picked && (
        <div className="mb-4 rounded-2xl border border-slate-200 bg-slate-50 p-3" data-testid="unregistered-profile">
          <div className="flex items-start justify-between gap-2 mb-3">
            <div className="min-w-0"><p className="font-bold text-[#1e3a5f] truncate">{picked.name || picked.email}</p><p className="text-xs text-slate-500 truncate">{picked.email} · no account</p></div>
            <button onClick={() => setPicked(null)} className="p-1 text-slate-400 hover:text-slate-600" data-testid="unregistered-profile-close"><X className="w-4 h-4" /></button>
          </div>
          <PersonActivityCard kind="unregistered" email={picked.email} />
        </div>
      )}
      <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[620px]">
          <thead className="text-xs text-slate-500 text-left bg-slate-50">
            <tr><th className="p-2.5">Buyer</th><th className="p-2.5 text-right">Orders</th><th className="p-2.5 text-right">Tickets</th><th className="p-2.5 text-right">Events</th><th className="p-2.5 text-right">Spent</th><th className="p-2.5">Last purchase</th></tr>
          </thead>
          <tbody>
            {rows === null ? <tr><td colSpan={6} className="p-6 text-center text-slate-400">Loading…</td></tr>
              : rows.length === 0 ? <tr><td colSpan={6} className="p-6 text-center text-slate-400" data-testid="unregistered-empty">No unregistered buyers found.</td></tr>
              : rows.map(r => (
                <tr key={r.email} onClick={() => setPicked(r)} className={`border-t cursor-pointer hover:bg-slate-50 ${picked?.email === r.email ? "bg-blue-50/50" : ""}`} data-testid={`unregistered-row-${r.email}`}>
                  <td className="p-2.5"><p className="font-semibold">{r.name || "—"}</p><p className="text-xs text-slate-500">{r.email}</p></td>
                  <td className="p-2.5 text-right">{r.orders}</td>
                  <td className="p-2.5 text-right">{r.tickets}</td>
                  <td className="p-2.5 text-right">{r.events}</td>
                  <td className="p-2.5 text-right font-semibold">{eur(r.spent)}</td>
                  <td className="p-2.5 text-xs text-slate-500">{fmt(r.last_purchase)}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
